import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';
import { RELATED_RESOURCES_COMPONENT_NAME } from './logRelatedResourceExposed';

export type ChatbotModalCloseBiData = {
  requestId: string | undefined;
  itemType: 'article' | 'video';
  itemName: string;
  position?: number;
  mediaUrls?: string;
};

/**
 * 4:1532 - the related-resources media modal was closed (X button, backdrop, Esc, or the Copilot
 * host dismissing its fullscreen viewer).
 */
export const logChatbotModalClose: BiEventLogger<ChatbotModalCloseBiData> = async (
  state,
  { requestId, itemType, itemName, position, mediaUrls },
) => {
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  await biLogger.chatbotModalClose(state, {
    session_id: sessionId,
    chatbot_view: contextBi?.chatbot_view,
    request_id: requestId,
    component_name: RELATED_RESOURCES_COMPONENT_NAME,
    item_type: itemType,
    item_name: itemName,
    position,
    media_urls: mediaUrls,
  });
};
